Array.prototype.forEach || (Array.prototype.forEach = function (r, o) {
  var t, n;
  if (null === this) throw new TypeError(" this is null or not defined");
  var e = Object(this),
    i = e.length >>> 0;
  if ("function" != typeof r) throw new TypeError(r + " is not a function");
  for (1 < arguments.length && (t = o), n = 0; n < i;) {
    var f;
    n in e && (f = e[n], r.call(t, f, n, e)), n++;
  }
});